define(["require", "exports", "./modal", "./analytics"], function (require, exports, modal_1, analytics_1) {
    "use strict";
    exports.__esModule = true;
    var ListMenu = (function () {
        function ListMenu(options, items) {
            var _this = this;
            this.options = options;
            this.items = items;
            this.$menu = $(this.render());
            $('body').append(this.$menu);
            this.$menu.find('.menu-item').click(function (e) {
                e.preventDefault();
                e.stopPropagation();
                var $item = $(e.currentTarget);
                var menuItem = _this.items[$item.index()];
                analytics_1["default"]('menu', 'click', menuItem.name);
                _this.hide();
                if (menuItem.onClick) {
                    _this.items[$item.index()].onClick();
                }
                else {
                    window.location.href = menuItem.href;
                }
            });
        }
        ListMenu.prototype.renderItem = function (item) {
            return "<li class=\"menu-item\">" + item.name + "</li>";
        };
        ListMenu.prototype.render = function () {
            var _this = this;
            return "<ul class=\"list-menu hidden " + (this.options.className || '') + "\">" + this.items.map(function (x) { return _this.renderItem(x); }).join('') + "</ul>";
        };
        ListMenu.prototype.show = function () {
            var _this = this;
            analytics_1["default"]('menu', 'open', this.options.anchor.attr('class'));
            this.$menu.toggleClass('hidden', false);
            modal_1.asModal(this.$menu).then(function () { _this.hide(); });
            var anchorOffset = this.options.anchor.offset();
            var anchorRect = this.options.anchor[0].getBoundingClientRect();
            this.$menu.offset({
                top: anchorOffset.top + anchorRect.height,
                left: anchorOffset.left + (this.options.align === 'right' ? anchorRect.width : 0) - this.$menu.width()
            });
            var top = anchorOffset.top;
        };
        ListMenu.prototype.hide = function () {
            this.$menu.toggleClass('hidden', true);
        };
        ListMenu.prototype.isOpen = function () {
            return !this.$menu.hasClass('hidden');
        };
        return ListMenu;
    }());
    exports.ListMenu = ListMenu;
    function ensureListMenu(options, items) {
        var menu = new ListMenu(options, items);
        options.anchor.data('listmenu', menu).click(function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (menu.isOpen()) {
                menu.hide();
            }
            else {
                menu.show();
            }
        });
    }
    exports.ensureListMenu = ensureListMenu;
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/listMenu.js
// module id = 83
// module chunks = 0